module.exports = __webpack_public_path__ + "img/logo.17013b75.png";